module.exports = "<section class=under_construction__wrapper><div class=under_construction__container><img class=under_construction__image src=/assets/images/gears.png alt=\" gears icon\"><p class=under_construction__text>Страницата е в процес на обновяване. Моля опитайте по-късно.</p></div></section>";


/*****************
 ** WEBPACK FOOTER
 ** ./client/public/under_construction/under_construction.html
 ** module id = 216
 ** module chunks = 0
 **/